import * as React from "react";
import { cn } from "~/lib/utils";

// // // //

export enum LoadingSpinnerVariants {
    Gray = "gray",
    Red = "red",
    Yellow = "yellow",
    Green = "green",
    Blue = "blue",
    Indigo = "indigo",
    Purple = "purple",
    Pink = "pink",
}
type LoadingSpinnerVariant = `${LoadingSpinnerVariants}`;

type Size = 3 | 4 | 5 | 6 | 8 | 10 | 24;

/**
 * A map of sizes to Tailwind class names.
 * This ensures Tailwind's JIT engine detects and includes these classes.
 */
const sizeClasses: Record<Size, string> = {
    3: "h-3 w-3",
    4: "h-4 w-4",
    5: "h-5 w-5",
    6: "h-6 w-6",
    8: "h-8 w-8",
    10: "h-10 w-10",
    24: "h-24 w-24",
};

/**
 * LoadingSpinner
 * Renders a circular progress spinner to indicate that the content on the page is reloading
 * From: https://flowbite.com/docs/components/spinner/
 */
export function LoadingSpinner(props: {
    variant?: LoadingSpinnerVariants | LoadingSpinnerVariant;
    size?: Size;
}) {
    const { size = 6, variant = "blue" } = props;
    const heightCss = sizeClasses[size];

    return (
        <svg
            className={cn("animate-spin", heightCss, {
                "text-slate-500": variant === LoadingSpinnerVariants.Gray,
                "text-red-500": variant === LoadingSpinnerVariants.Red,
                "text-yellow-500": variant === LoadingSpinnerVariants.Yellow,
                "text-green-500": variant === LoadingSpinnerVariants.Green,
                "text-blue-500": variant === LoadingSpinnerVariants.Blue,
                "text-indigo-500": variant === LoadingSpinnerVariants.Indigo,
                "text-purple-500": variant === LoadingSpinnerVariants.Purple,
                "text-pink-500": variant === LoadingSpinnerVariants.Pink,
            })}
            role="status"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            ></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    );
}
